'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var USER_ERROR_GROUP = 'User';
var APP_ERROR_GROUP = 'Error';
var EDM_ERROR_GROUP = 'EDM';

var markUserError = function markUserError(error) {
  return markError(error, USER_ERROR_GROUP);
};

var markAppError = function markAppError(error) {
  return markError(error, APP_ERROR_GROUP);
};

var markError = function markError(error, marker) {
  if (error && (typeof error === 'undefined' ? 'undefined' : _typeof(error)) === 'object') {
    error.errorGroup = marker;
  }
};

var isUserError = function isUserError(error) {
  return error && error.errorGroup === USER_ERROR_GROUP;
};

var isAppError = function isAppError(error) {
  return error && error.errorGroup === APP_ERROR_GROUP;
};

var isMarked = function isMarked(error) {
  if (!error) {
    return false;
  }

  return error.errorGroup !== undefined;
};

module.exports = { markUserError: markUserError, isUserError: isUserError, markAppError: markAppError, isAppError: isAppError, markError: markError, isMarked: isMarked, USER_ERROR_GROUP: USER_ERROR_GROUP, APP_ERROR_GROUP: APP_ERROR_GROUP, EDM_ERROR_GROUP: EDM_ERROR_GROUP };


//////////////////
// WEBPACK FOOTER
// ../node_modules/cloud-base-errors-definitions/lib/error-marks.js
// module id = 65
// module chunks = 0